import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';

// These should be set as environment variables in production
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

// Helper function to set user context for RLS
export const setUserContext = async (telegramId: number, userId: string) => {
  const { error } = await supabase.rpc('set_user_context', {
    telegram_id: telegramId,
    user_id: userId,
  });
  
  if (error) {
    console.error('Error setting user context:', error);
    throw error;
  }
};

// Helper function to clear user context
export const clearUserContext = async () => {
  const { error } = await supabase.rpc('clear_user_context');
  
  if (error) {
    console.error('Error clearing user context:', error);
  }
};